/**
 * Created by Анжелика on 20.06.2017.
 */
import React, {Component} from 'react';
import update from "react-addons-update";
import PropTypes from 'prop-types';
import * as strings from '../constants/strings';
import * as errors from '../constants/errors';
import ErrorBlock from './ErrorBlock';
import FormInput from './FormInput';
import Button from './Button';

class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null
        }
    }

    onKeyDown(e) {
        switch (e.keyCode) {
            case 13:
                this.doLogin();
                break;

            default:
                break;
        }
    }

    onFieldChanged(field) {
        return e => {
            let newState = update(this.state, {
                [field]: {$set: e.target.value}
            });
            this.setState(newState);
        }
    }

    validate() {
        if (!this.state.login || !this.state.password) {
            this.setState({error: errors.VALIDATION_LOGIN_ERROR});
            return false;
        } else {
            this.setState({error: null});
            return true;
        }
    }

    doLogin() {
        const {login} = this.props;
        if (this.validate()) {
            login(this.state.login, this.state.password);
        }
    }

    render() {
        const {error, switchToRegistration} = this.props;
        const error_description = this.state.error || error;
        return (
            <div className="modal login">
                <h3>Войти для просмотра</h3>

                {error_description && <ErrorBlock error_description={error_description} />}
                <form onKeyDown={e => this.onKeyDown(e)}>

                    <FormInput name="login" autoFocus={true} label={strings.STR_LOGIN_LOGIN}
                               placeholder={strings.STR_LOGIN_PLACEHOLDER_LOGIN}
                               onFieldChanged={this.onFieldChanged('login')}/>

                    <FormInput name="password" type="password" label={strings.STR_LOGIN_PASSWORD}
                               placeholder={strings.STR_LOGIN_PLACEHOLDER_PASSWORD}
                               onFieldChanged={this.onFieldChanged('password')}/>

                    <div className="form-group">
                        <div className="btn-toolbar">
                            <Button onClick={this.doLogin.bind(this)}>{strings.STR_LOGIN_ENTRY}</Button>
                        </div>
                        {/*<div className="btn-toolbar">*/}
                            {/*<Button className="register" onClick={switchToRegistration}>{strings.STR_LOGIN_REGISTRATION}</Button>*/}
                        {/*</div>*/}
                    </div>
                </form>
            </div>
        )
    }
}

Form.propTypes = {
    error: PropTypes.string,
    login: PropTypes.func.isRequired,
    switchToRegistration: PropTypes.func.isRequired
};

export default Form;


// WEBPACK FOOTER //
// ./src/components/Form.js